//#region types
import { TextInputProps } from "models/propTypes/wintFormPropsTypes";
//#endregion
//#region components
import BaseInput from "./baseInput";
import { FormControl } from "@mui/material";
//#endregion
import cssExports from "theme/styles/main.module.scss";

function TextInput(props: TextInputProps) {
  return (
    <FormControl fullWidth className={cssExports.inputFormControl}>
      <BaseInput
        {...props}
        type={props.type ?? "text"}
        value={props.value ?? ""}
        data-testid={`${props.name}TextInput`}
      />
    </FormControl>
  );
}

export default TextInput;
